import React, { useEffect, useState } from 'react';
import { Typography, Steps } from 'antd';
import { TripStep } from './trip-step-1';
import { RouteStep } from './trip-step-2';
import { BoardingPointComponent } from './../boarding-points/boarding-points.component';
import { DropPointComponent } from './../drop-points/drop-points.component';
import { isValid } from '../../../utils/utilities';
import { getBusDetailsAction } from '../../../actions/trip-create.actions';
import { tripReducerSelector } from "../../../selector/trip-selectors";
import { useSelector, useDispatch } from 'react-redux';
import { getScheduleById, clearSelectedTrip, getRoutesByTripId } from '../../../actions/trip-actions';
import { useHistory } from "react-router-dom";
import { getCityDetails } from '../../../actions/cities.actions';
import { citiesDataSelector } from './../../../selector/cities.selector';
import './trip-root.style.scss';

const { Step } = Steps;
const { Text } = Typography;

export const EasyTripCreateComponent = (props) => {

  const history = useHistory();

  const [tripFormData, setTripFormData] = useState({});
  let locationReducer = useSelector(citiesDataSelector);
  let tripReducer = useSelector(tripReducerSelector);
  let dispatch = useDispatch();

  let {
    scheduleId
  } = props;

  const [stepno, updateStep] = useState(0);

  useEffect(() => {
    dispatch(getCityDetails(() => { }, () => { }))
    dispatch(getBusDetailsAction());
  }, []);

  useEffect(() => {
    if (isValid(scheduleId)) {
      dispatch(getScheduleById(scheduleId));
      dispatch(getRoutesByTripId(scheduleId));
    }
  }, [scheduleId])

  const {
    selectedTrip
  } = tripReducer;

  useEffect(() => {
    setTripFormData(selectedTrip);
  }, [selectedTrip]);

  let isTripCreated = isValid(selectedTrip) && isValid(selectedTrip.id) ? true : false;

  const onTripClear = () => {
    history.push({
      pathname: '/easytrip'
    });
    dispatch(clearSelectedTrip());
  }

  const onTripCreateSuccess = (id) => {
    if (isValid(id)) {
      history.push({
        pathname: '/easytrip',
        search: `?scheduleId=${id}`,
        state: { scheduleId: id }
      });
    }
  }

  return (
    <div className="easy-trip-steps-container">
      <Text>Create Trip</Text>
      <Steps direction="vertical"
        current={stepno}
        onChange={(current) => {
          updateStep(current);
        }}
      >
        <Step
          title={isTripCreated ? selectedTrip.description : "Select Origin & Destination"}
          description={stepno == 0 ? <div className="step-content-wrapper"><TripStep
            showFareInfo={true}
            formData={tripFormData}
            showCancelButton={true}
            onClear={onTripClear}
            onCreateSuccess={onTripCreateSuccess}
            showEditBlockSeats={true}
            showUpdateButton={true}
          /></div> : ''} />
        <Step
          title="Add Via Cities"
          description={stepno == 1 ? <div className="step-content-wrapper"><RouteStep citiesData={locationReducer.cities}
            {...tripReducer}
          /></div> : ''}
          disabled={!isTripCreated}
        />
        <Step
          title="Add Boarding Points"
          description={stepno == 2 ? <div className="step-content-wrapper"><BoardingPointComponent {...tripReducer}
            isRowClickable={true}
            showDeleteUpdateButtons={true}
          /></div> : ''}
          disabled={!isTripCreated}
        />
        <Step
          title="Add Drop Points"
          description={stepno == 3 ? <div className="step-content-wrapper"><DropPointComponent {...tripReducer}
            isRowClickEnabled={true}
            showDeleteUpdateButtons={true}
          /></div> : ''}
          disabled={!isTripCreated}
        />
      </Steps>
    </div>
  );
}
